// extracted by mini-css-extract-plugin
module.exports = {"tmsg":"Collaborations_tmsg__3ddF5","consultationCorner":"Collaborations_consultationCorner__6GDST","en":"Collaborations_en__3DeO3","ccc":"Collaborations_ccc__3Ah2X"};